import { render, staticRenderFns } from "./SendPaymentReminder.vue?vue&type=template&id=7c2309fa"
import script from "./SendPaymentReminder.vue?vue&type=script&lang=js"
export * from "./SendPaymentReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports